import axios from 'axios'
import Config from '@/settings'
import { getToken, removeToken } from '@/utils/auth'
import router from '../router'

// 创建axios实例
const service = axios.create({
    // # api 的 base_url
    baseURL: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_API : '/',
    // # 请求超时时间
    timeout: Config.timeout
})

// # request 拦截器
service.interceptors.request.use(
    config => {
        // # 让每个请求携带自定义token
        let tokent = getToken()
        if (tokent) {
            config.headers['Authorization'] = tokent
        }
        // # 设置 application/json 模式提交
        config.headers['Content-Type'] = 'application/json'
        return config
    },
    error => {
        Promise.reject(error)
    }
)

// # response 拦截器
service.interceptors.response.use(
    response => {
        return response.data
    },
    error => {
        if (error && error.response) {
            // # 根据返回的状态码进行不同的操作
            switch (error.response.status) {
                case 401:
                // # 如果状态码为401，跳转到登录页面
                removeToken()
                router.push('/login')
                break
                // # 可以添加其他状态码的处理逻辑
                default:
                // # 其他错误情况的处理
            }
        }
        // # 全局错误提示处理
        return Promise.reject(error)
    }
)
export default service